module.exports = __webpack_public_path__ + "img/logo.3a27b90c.png";